__turbopack_context__.v({
  "button": "styles-module-scss-module__RVNnYa__button",
  "capitalize": "styles-module-scss-module__RVNnYa__capitalize",
  "status": "styles-module-scss-module__RVNnYa__status",
});
